import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import blogdata from '../../JsonData/blogdata.json';
import moment from 'moment';

const PostList = () => {
  const [bloglist, setBlogList] = useState([]);

  useEffect(() => {
    setBlogList(blogdata.blogs);
  }, []);

  return (
    <div className="property-news-area py-5">
      <style>{`
        .blog-card {
          border: none;
          border-radius: 10px;
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          background-color: #fff;
          box-shadow: 0 0 0 rgba(0, 0, 0, 0);
        }

        .blog-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }

        .blog-image-wrapper {
          position: relative;
          height: 200px;
          overflow: hidden;
        }

        .blog-image-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .category-label {
          position: absolute;
          top: 10px;
          left: 10px;
          background-color: rgba(0, 0, 0, 0.65);
          color: #fff;
          font-size: 14px;
          padding: 6px 12px;
          border-radius: 4px;
          font-weight: 500;
        }

        .card-title {
          font-size: 1.05rem;
          font-weight: 600;
          min-height: 60px;
        }

        @media (max-width: 768px) {
          .card-title {
            min-height: auto;
          }
        }
      `}</style>

      <div className="container">
          <div className="section-title"> 
            <h2 className="title">Recent Blogs</h2>
            <Link className="btn-view-all" to="/blog">View All</Link>
          </div>
        <div className="row">
        
          {bloglist.map((item) => (
            <div className="col-lg-4 col-md-6 mb-4" key={item.ID}>
              <div className="blog-card h-100">
                {/* <Link to={`/blogdetails/Blog=${item.Slug}`}> */}
                <Link to={`/blogdetails/${item.Slug}`}>

                  <div className="blog-image-wrapper">
                    <img
                      src={item.FeaturedImage}
                      className="card-img-top"
                      alt={item.Title}
                    />
                    <div className="category-label">Trinestsky</div>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">{item.Title}</h5>
                    <p className="text-muted small mb-2">
                      {moment(item.publishedDate).format('MMMM DD, YYYY')}
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostList;
